import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { DashboardContext } from "../../context/DashboardContext";
import { NO_ACCESS_TYPES } from "../../utils/constants";

import DashboardPlaceholder from "./Loading/DashboardPlaceholder";

import stopIllustration from "../../assets/images/stop.svg";

function AccessControl({ requiredPermission, noAccessType, children }) {
    const context = useContext(DashboardContext);
    const navigate = useNavigate();

    const hasPermission = Array.isArray(requiredPermission)
        ? requiredPermission.every(p => context.userPermissions.includes(p))
        : context.userPermissions.includes(requiredPermission);

    useEffect(() => {
        if (!context.permissionsLoading) {
            if (!hasPermission) {
                if (noAccessType === NO_ACCESS_TYPES.REDIRECT) {
                    if (context.userPermissions.length === 1 && context.userPermissions.includes("CP-A-PPP")) {
                        navigate("/welcome");
                    } else {
                        navigate("/no-permission");
                    }
                }
            }
        }
    }, [context.permissionsLoading, context.userPermissions, hasPermission, navigate, noAccessType, requiredPermission]);

    return context.permissionsLoading ? (
        <DashboardPlaceholder />
    ) : hasPermission ? (
        children
    ) : (
        noAccessType === NO_ACCESS_TYPES.ERRORTEXT && (
            <div
                className={
                    "text-sm w-full mx-auto rounded-md px-3 py-3 info " +
                    "bg-amber-100 text-amber-700 align-center justify-center"
                }
            >
                <div className={"flex items-center justify-center"}>
                    <img className={"w-3/4"} alt="" src={stopIllustration} />
                </div>
                <div className={"font-medium text-base mt-4"}>You do not have the necessary permissions</div>
                <div className={"mt-2"}>
                    You do not have the necessary permissions required to view this page, section or to perform this
                    action. Please contact your supervisor if this was unexpected.
                </div>
            </div>
        )
    );
}

export default AccessControl;
